import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBnv = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "200.01869mm",
	height: "18.930111mm",
	viewBox: "0 0 200.01869 18.930111",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("g", {
		id: "layer1",
		transform: "translate(-33.358181,-41.00976)",
		children: /* @__PURE__ */ _jsx("text", {
			xmlSpace: "preserve",
			style: {
				fontSize: "3.175px",
				textAlign: "start",
				letterSpacing: "0.251354px",
				writingMode: "lr-tb",
				direction: "ltr",
				textAnchor: "start",
				fill: "currentColor",
				fillOpacity: 0,
				strokeWidth: .264583
			},
			x: 31.109222,
			y: 59.559532,
			id: "text1",
			children: /* @__PURE__ */ _jsxs("tspan", {
				id: "tspan1",
				style: {
					fontStyle: "normal",
					fontVariant: "normal",
					fontWeight: "normal",
					fontStretch: "normal",
					fontSize: "25.4px",
					fontFamily: "sans-serif",
					InkscapeFontSpecification: "'sans-serif, Normal'",
					fontVariantLigatures: "normal",
					fontVariantCaps: "normal",
					fontVariantNumeric: "normal",
					fontVariantEastAsian: "normal",
					letterSpacing: "0.251354px",
					fill: "currentColor",
					fillOpacity: 1,
					stroke: "currentColor",
					strokeWidth: .264583,
					strokeOpacity: 1
				},
				x: 31.109222,
				y: 59.559532,
				children: [/* @__PURE__ */ _jsx("tspan", {
					style: {
						fontStyle: "normal",
						fontVariant: "normal",
						fontWeight: 600,
						fontStretch: "normal",
						fontSize: "25.4px",
						fontFamily: "'Open Sans'",
						InkscapeFontSpecification: "'Open Sans, Semi-Bold'",
						fontVariantLigatures: "normal",
						fontVariantCaps: "normal",
						fontVariantNumeric: "normal",
						fontVariantEastAsian: "normal",
						letterSpacing: "0.251354px"
					},
					id: "tspan3",
					children: "BNV"
				}), /* @__PURE__ */ _jsx("tspan", {
					style: {
						fontStyle: "normal",
						fontVariant: "normal",
						fontWeight: 300,
						fontStretch: "normal",
						fontSize: "25.4px",
						fontFamily: "'Open Sans'",
						InkscapeFontSpecification: "'Open Sans, Light'",
						fontVariantLigatures: "normal",
						fontVariantCaps: "normal",
						fontVariantNumeric: "normal",
						fontVariantEastAsian: "normal",
						letterSpacing: "0.251354px"
					},
					id: "tspan2",
					children: "MANAGER"
				})]
			})
		})
	})]
});
export default SvgBnv;
